<template>
  <div class="context">
    <canvas id="canvas" style="position: absolute; top: 0; left: 0"></canvas>
    <div class="grid" style="z-index: 1">
      <div class="cell y-start x-start">{{ date }}</div>
      <div class="cell y-start x-mid">{{ location }}</div>
      <div class="cell y-start x-end">{{ time }}</div>
      <div class="cell y-mid x-mid">
        <div class="main_wrapper" @click="toggle">
          <div
            :class="[
              'logo_wrapper',
              'fx-toggle',
              toggle_state === TOGGLE_LOGO ? 'active' : 'inactive',
            ]"
          >
            <div style="font-size: 8rem" data-glitch>DN</div>
            <div style="font-size: 1.6rem">David Nikzad</div>
            <div
              style="font-size: 8rem; letter-spacing: 0.1em; text-indent: 0.2em"
              data-glitch
            >
              1111
            </div>
          </div>
          <div
            :class="[
              'info',
              'fx-toggle',
              toggle_state === TOGGLE_INFO ? 'active' : 'inactive',
            ]"
          >
            <h1 :class="['h1']" style="text-transform: uppercase">
              My name is David Nikzad
            </h1>
            <div style="line-height: 1.5">
              <p>
                I’m a serial entrepreneur and investor, and I’ve dedicated my
                career to these ideals. I want to extend this vision to my
                friends and associates so that together we can increase the
                power of our collective consciousness to drive these beliefs
                forward.
              </p>
              <p>
                Orthogonal is a group of people committed to investing broadly
                across a range of companies — from inspired start-ups to
                later-stage, growing firms. Together, we support technologies in
                farming, earth-friendly packaging, progressive plant medicines,
                and other universally positive initiatives.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="cell y-end x-start">
        <!-- <button
          :class="['button', 'toggle-button', 'x-underline-fx']"
          @click="toggle"
        >
          {{ toggle_text }}
        </button> -->
        <button :class="['button', 'calendly-button', 'x-underline-fx']">
          Schedule a call
        </button>
      </div>
      <div class="cell y-end x-mid">
        <a
          :class="['button', 'toggle-button', 'x-underline-fx']"
          href="https://instagram.com/davidnikzad1111/"
          target="_blank"
        >
          <img
            src="/instagram-icon.svg"
            width="1000"
            height="1000"
            alt="Instagram icon"
            style="width: 1rem; height: auto"
          />
        </a>
        <a
          :class="['button', 'toggle-button', 'x-underline-fx']"
          href="https://x.com/Nikzad1111David"
          target="_blank"
        >
          <img
            src="/x-icon.svg"
            width="1200"
            height="1227"
            alt="X icon"
            style="width: 1rem; height: auto"
          />
        </a>
      </div>
      <div class="cell y-end x-end">
        <button
          :class="['button', 'contact-button', 'x-underline-fx']"
          data-tally-open="3XkyvY"
          data-tally-layout="modal"
          data-tally-hide-title="1"
        >
          Send me a message
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  metaInfo: {
    title: "About Us",
  },
  // mounted() {
  //   createScript({
  //     src: "https://tally.so/widgets/embed.js",
  //     id: "contact-us",
  //     defer: true, // to not slow down SVG animation
  //   });
  //   // window.mana_fluid = {
  //   //   container: document.querySelector(".context"),
  //   //   color_1_hue: 0.85,
  //   //   color_2_hue: 0.51,
  //   // };
  //   // createScript({
  //   //   src: "/mana-fluid-fx.js",
  //   //   id: "mana-fluid-fx",
  //   //   async: true,
  //   // });
  // },
};
</script>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

function createLink(options = {}) {
  const { href, rel, id } = options;
  if (!id) throw new Error("Link ID is required");
  if (document.getElementById(id)) return;

  const link = document.createElement("link");
  link.href = href;
  link.rel = rel;
  link.id = id;

  document.head.appendChild(link);
}

function createScript(options = {}) {
  // TODO Support script content
  const { src, id, async = false, defer = false } = options;
  if (!id) throw new Error("Script ID is required");
  if (document.getElementById(id)) return;

  const script = document.createElement("script");

  script.id = id;
  script.src = src;
  script.async = async;
  script.defer = defer;

  document.head.appendChild(script);
  script.onload = () => {
    console.log(`Script ${id} loaded successfully`);
    options.onload && options.onload();
  };
  script.onerror = () => {
    console.error(`Script ${id} failed to load`);
    options.onerror && options.onerror();
  };
}

const getRandom = (ary) => ary[Math.floor(Math.random() * ary.length)];

function initCanvas() {
  const canvas = document.getElementById("canvas");
  if (!canvas) return;
  const ctx = canvas.getContext("2d");

  const s = canvas.style;
  const w = (canvas.width = document.body.offsetWidth);
  const h = (canvas.height = document.body.offsetHeight);
  const cols = Math.floor(w / 20) + 1;
  const ypos = Array(cols).fill(0);

  ctx.fillStyle = "#000";
  ctx.fillRect(0, 0, w, h);

  function matrix() {
    ctx.fillStyle = "#0001";
    ctx.fillRect(0, 0, w, h);

    ctx.fillStyle = "#222";
    ctx.font = "15pt monospace";

    ypos.forEach((y, ind) => {
      // const text = String.fromCharCode(Math.random() * 128);
      // const text = Math.random() > 0.5 ? "0" : "1";
      const text = getRandom("DAVID NIKZAD 1111");

      const x = ind * 20;
      ctx.fillText(text, x, y);

      if (y > 100 + Math.random() * 10000) ypos[ind] = 0;
      else ypos[ind] = y + 20;
    });
  }

  let lastTime = 0;
  const fpsInterval = 1000 / 10; // 100ms
  function matrixLoop(timestamp) {
    if (timestamp - lastTime >= fpsInterval) {
      lastTime = timestamp;
      matrix();
    }
    requestAnimationFrame(matrixLoop);
  }

  requestAnimationFrame(matrixLoop);
}

const location = "O‘AHU HAWAII";
const locale = "en-US";
const dateFormat = {
  timeZone: "Pacific/Honolulu",
  year: "numeric",
  month: "numeric",
  day: "numeric",
};
const timeFormat = {
  timeZone: "Pacific/Honolulu",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  timeZoneName: "short",
};

const datetime = new Date();
const date = ref(datetime.toLocaleDateString(locale, dateFormat));
const time = ref(datetime.toLocaleTimeString(locale, timeFormat));

let timeUpdate;

onMounted(() => {
  timeUpdate = setInterval(() => {
    const datetime = new Date();
    date.value = datetime.toLocaleDateString(locale, dateFormat);
    time.value = datetime.toLocaleTimeString(locale, timeFormat);
  }, 1000);
});

onUnmounted(() => {
  clearInterval(timeUpdate);
});

let tally = false;

onMounted(() => {
  if (!tally) {
    tally = true;
    createScript({
      src: "https://tally.so/widgets/embed.js",
      id: "contact-us",
      defer: true, // to not slow down SVG animation
    });
  }
});

/*
let powerglitch = false;

const randomInt = (min, max) => ((Math.random() * (max - min)) | 0) + min;
const randomFloat = (min, max) => Math.random() * (max - min) + min;

onMounted(() => {
  if (!powerglitch) {
    powerglitch = true;
    // min, max - lower and higher effect repetition timeouts
    const makeGlitch = (element, config, min = 5, max = 10) => {
      const { startGlitch, stopGlitch } = window.PowerGlitch.glitch(element, {
        playMode: "manual",
        ...config,
      });
      const r = () => randomFloat(min, max);
      const run = () => {
        startGlitch();
        setTimeout(run, r() * 1000);
      };
      setTimeout(run, r() * 1000);
    };

    createScript({
      src: "/powerglitch.min.js",
      id: "powerglitch",
      async: true,
      onload: () => {
        for (let element of document.querySelectorAll("[data-glitch]")) {
          makeGlitch(
            element,
            {
              shake: { velocity: randomInt(0, 3) },
              slice: { velocity: randomInt(4, 7) },
            },
            3,
            12
          );
        }
      },
    });
  }
});
*/

onMounted(() => {
  window.addEventListener("resize", initCanvas);
  initCanvas();
});

onUnmounted(() => {
  // clearInterval(timeUpdate);
  console.log("REMOVE");
  window.removeEventListener("resize", initCanvas);
});

onMounted(() => {
  createLink({
    href: "https://assets.calendly.com/assets/external/widget.css",
    rel: "stylesheet",
    id: "calendly-css",
  });
  createScript({
    src: "https://assets.calendly.com/assets/external/widget.js",
    id: "calendly-script",
    async: true,
    onload: () => {
      document.querySelectorAll(".calendly-button").forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          window.Calendly.initPopupWidget({
            url: "https://calendly.com/davidnikzad/30min",
          });
        });
      });
    },
  });
});

const TOGGLE_LOGO = "TOGGLE_LOGO";
const TOGGLE_INFO = "TOGGLE_INFO";

const toggle_state = ref(TOGGLE_LOGO);
const toggle_text = ref("Info");

function toggle(event) {
  if (toggle_state.value === TOGGLE_LOGO) {
    toggle_state.value = TOGGLE_INFO;
    toggle_text.value = "Close";
  } else {
    toggle_state.value = TOGGLE_LOGO;
    toggle_text.value = "Info";
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.context {
  position: relative;
  color: #fff;
  background: #000;
}

.grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  grid-template-rows: auto 1fr auto 1fr auto;
  min-width: 100vw;
  min-width: 100dvw;
  min-height: 100vh;
  min-height: 100dvh;
}

.cell {
  padding: 1rem 1.5rem;

  justify-self: center;
  align-self: center;
  text-align: center;

  text-transform: uppercase;
  --first: 1;
  --middle: 3;
  --last: 5;
}

.y-start {
  align-self: top;
}
.y-mid {
  align-self: center;
}
.y-end {
  align-self: bottom;
}

.x-start {
  justify-self: flex-start;
  text-align: left;
}

.x-mid {
  text-align: center;
}

.x-end {
  justify-self: flex-end;
  text-align: right;
}

.y-start.x-start {
  grid-row: var(--first);
  grid-column: var(--first);
}

.y-start.x-mid {
  grid-row: var(--first);
  grid-column: var(--middle);
}

.y-start.x-end {
  grid-row: var(--first);
  grid-column: var(--last);
}

.y-mid.x-start {
  grid-row: var(--middle);
  grid-column: var(--first);
}

.y-mid.x-mid {
  grid-row: var(--middle);
  grid-column: var(--middle);
}
@media screen and (max-width: 512px) {
  .y-mid.x-mid {
    grid-column: var(--first) / span var(--last);
  }
}

.y-mid.x-end {
  grid-row: var(--middle);
  grid-column: var(--last);
}

.y-end.x-start {
  grid-row: var(--last);
  grid-column: var(--first);
}

.y-end.x-mid {
  grid-row: var(--last);
  grid-column: var(--middle);
}

.y-end.x-end {
  grid-row: var(--last);
  grid-column: var(--last);
}

.main_wrapper {
  position: relative;
}

.logo_wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.button {
  padding: 0.5rem 1rem;
  border: none;
  text-transform: inherit;
  background: none;
  color: inherit;
  cursor: pointer;
}

.toggle-button {
  margin: 0 0 -1rem -0.5rem;
}
.contact-button {
  margin: 0 -0.5rem -1rem 0;
}

.email {
  color: inherit;
  text-decoration: none;
  text-transform: none;
}

.fx-toggle {
  opacity: 0;
  transition: opacity 1s ease;
}
.fx-toggle.active {
  opacity: 1;
}
</style>
